import "./OutrasDeducoes.css";

export interface OutraDeducaoItem {
  descricao?: string;
  valor?: number;
}

interface OutrasDeducoesProps {
  itens?: OutraDeducaoItem[] | null;
  totalDeduzir?: number;
}

const formatCurrency = (v: number | string | undefined) =>
  (Number(v) || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const OutrasDeducoes = ({ itens = [], totalDeduzir = 0 }: OutrasDeducoesProps) => {
  const rows = Array.isArray(itens) ? itens : [];
  if (rows.length === 0) return null;

  return (
    <div className="card shadow-sm p-4 mb-4 card-rounded">
      <h5 className="fw-bold text-uppercase pb-2 mb-3 text-primary">
        Outras deduções
      </h5>

      <div className="table-rounded-wrapper">
        <table className="table table-outras-deducoes mb-0">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, idx) => (
              <tr key={`${item.descricao}-${idx}`}>
                <td>{item.descricao || "-"}</td>
                <td className="text-end">{formatCurrency(item.valor)}</td>
              </tr>
            ))}
            <tr className="row-total-deduzir">
              <td className="text-end fw-bold">VALOR TOTAL A DEDUZIR:</td>
              <td className="text-end fw-bold valor-total-deduzir">
                {formatCurrency(totalDeduzir)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OutrasDeducoes;
